<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" :width="800">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item name="id">
                    <a-input v-model:value="form.id" placeholder="请输入id"/>
                </a-form-item>
                <a-form-item name="type">
                    <a-input v-model:value="form.type" placeholder="请输入类型"/>
                </a-form-item>
            </div>
            <a-form-item label="联盟名称" name="name">
                <a-input v-model:value="form.name" placeholder="请输入联盟名称"/>
            </a-form-item>
            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-item label="联盟办公地址" name="address">
                        <a-input v-model:value="form.address" placeholder="请输入技术中心办公地址"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联盟认定时间" name="attestationTime">
                        <DatePicker v-model:value="form.attestationTime" placeholder="请输入技术中心认定时间" style="width: 100%"/>
                    </a-form-item>
                </a-col>
            <a-col :span="12">
                <a-form-item label="技术领域" name="researchDirection">
                    <DictSelect
                        v-model:value="form.researchDirection"
                        :dict-name="innovation.TECHNICAL_FIELD"
                        placeholder="请选择"
                    />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="总人数" name="totalStaff">
                    <a-input-number v-model:value="form.totalStaff" :min="0" :precision="0" style="width: 100%" placeholder="总人数"/>
                </a-form-item>
            </a-col>
            </a-row>

            <a-row :gutter="24">
                <a-col :span="12">
                    <a-form-item label="联盟理事长" name="headName">
                        <a-input v-model:value="form.headName" :min="0" :precision="0" style="width: 100%" placeholder="联盟理事长"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="理事长联系电话" name="headPhone">
                        <a-input v-model:value="form.headPhone" :min="0" :precision="0" style="width: 100%" placeholder="理事长联系电话"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="牵头单位联系人" name="contacts">
                        <a-input v-model:value="form.contacts" :min="0" :precision="0" style="width: 100%" placeholder="牵头单位联系人"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="牵头单位联系人电话" name="contactsPhone">
                        <a-input v-model:value="form.contactsPhone" :min="0" :precision="0" style="width: 100%" placeholder="牵头单位联系人电话"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="联盟成员名单" name="cooperationUnit">
                        <a-textarea v-model:value="form.cooperationUnit" placeholder="请输入联盟成员名单，中间用英文','隔开"
                                    :auto-size="{minRows:3,maxRows:5}"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import {formMixin} from "@/mixins";
// import dataCheck from "@/utils/dataCheck";
import {ScientificApi} from "@/api/innovationService";
import {companyOriginInfo} from "@/api/tenantService";
import DatePicker from "@/components/form/datePicker/DatePicker";
import {innovation} from "@/config/variableConfig"
import DictSelect from "@/components/other/DictSelect";
export default {
    name: "addOrEditModal",
    mixins: [formMixin],
    components: {DatePicker,DictSelect},
    data() {
        return {
            options: [],
            innovation,
            /*表单绑定值与验证规则定义*/
            form: {
                id: null,
                cooperationUnit: null,
                name: null,
                totalStaff: null,
                researchDirection: null,
                attestationTime: null,
                type: null,
                contacts: null,
                contactsPhone: null,
                address: null,
                headName: null,
                headPhone: null,
            },
            rules: {
                id: [],
                cooperationUnit: [],
                name: [],
                totalStaff: [],
                researchDirection: [],
                attestationTime: [],
                type: [],
                contacts: [],
                contactsPhone: [],
                address: [],
                headName: [],
                headPhone: [],
            },
            /*提交表单地址*/
            submitUrl: ScientificApi.saveOrUpdate
        }
    },
    mounted() {
        this.getCompany()
    },
    methods: {
        filterOption(input, option) {
            return (
                option.children[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        getCompany() {
            this.getAction({
                url: companyOriginInfo.List
            }).then(res => {
                this.options = res
            })
        }
    },
}
</script>
<style scoped lang="less">

</style>
